export const SET_TRIGGERS_TABLE_ANALYSIS_AXIS = 'SET_TRIGGERS_TABLE_ANALYSIS_AXIS';

export const setTriggersTableAnalysisAxis = analysisAxis => {
  return {
    type: SET_TRIGGERS_TABLE_ANALYSIS_AXIS,
    data: analysisAxis,
  };
};
